import { HOST, API_URL, ENV } from "@/config";

export const FREE_USER_DOMAIN = "app.myaltimate.com";
export const FREE_MEGATENANT = "freemegatenant.demo.tryaltimate.com";
export const MEGA_TENANT = "megatenant";

export const getTenant = () => {
  // 1. Check if tenant is injected by preview server (path-based routing)
  if (window.__TENANT__) {
    return window.__TENANT__;
  }

  // 2. Extract from subdomain (production behavior)
  const myDomain = window.location.host;
  if (!myDomain.includes("." + HOST)) return "";
  return myDomain.replace("." + HOST, "");
};

const CODE_QUERY = "codeQuery";
const LINEAGE = "lineage";
const FREE_STACK = "freeStack";
const IS_INSTANCE = "isInstance";
const SHOW_PREMIUM_DATAPILOT = "showPremiumDatapilot";
const SHOULD_REDIRECT_TO_TEAM_SPENDS = "shouldRedirectToTeamSpends";
const SHOW_ENTERPRISE_DATA_DISCOVERY = "showEnterpriseDataDiscovery";
const SHOW_ENTERPRISE_EDITION_SUGGESTION = "showEnterpriseEditionSuggestion";
const JOBS = "jobs";
const SSO_ENABLED = "ssoEnabled";
const SHOW_WORKFLOW = "showWorkflow";
const SHOW_AZURE_DATABRICKS_CONNECTIONS = "showAzureDatabricksConnections";

const featureFlags = {
  [CODE_QUERY]: getTenant() !== "silq",
  [JOBS]: ![
    "shs",
    "block",
    "dat",
    "rampdata",
    "cisco",
    "qaebates",
    "meraki",
    "pepsiaws-us-east",
    "pepsico",
    "rubrik",
  ].includes(getTenant()),
  [LINEAGE]: getTenant() !== "silq",
  [FREE_STACK]:
    window.location.hostname.includes(FREE_USER_DOMAIN) ||
    window.location.hostname.includes(FREE_MEGATENANT),
  [IS_INSTANCE]: window.location.hostname.includes("localhost")
    ? window.location.hostname !== HOST?.split(":")[0]
    : window.location.hostname !== HOST,
  [SHOW_PREMIUM_DATAPILOT]: getTenant() === "eastman",
  [SSO_ENABLED]: [
    "msmg",
    "cisco",
    "eastman",
    "dat",
    "meraki",
    "shs",
    "block",
    "zscaler",
    "zscaler-corp",
    "zscalercorp",
    "zscaler-datafabric",
    "zscaler-avalor",
    "docusign",
    "duo",
    "dbtdemo",
    "rakuten",
    "coinbase",
    "azuresso",
    "intuitive",
    "rubrik",
    "pepsico",
    "sunrun",
    "harvestgroup",
  ].includes(getTenant()),
  [SHOW_ENTERPRISE_DATA_DISCOVERY]: getTenant() === "msmg",
  [SHOW_ENTERPRISE_EDITION_SUGGESTION]: getTenant() !== "msmg",
  [SHOULD_REDIRECT_TO_TEAM_SPENDS]: ["block"].includes(getTenant()),
  [SHOW_WORKFLOW]: getTenant() === "megatenant",
  [SHOW_AZURE_DATABRICKS_CONNECTIONS]: ["dbxpepsico", "dbxmegatenant"].includes(getTenant()),
};

export const isCodeQuery = () => featureFlags[CODE_QUERY];
export const isLineage = () => featureFlags[LINEAGE];
export const isFreeStack = () => featureFlags[FREE_STACK];
export const showPremiumDatapilot = () => featureFlags[SHOW_PREMIUM_DATAPILOT];
export const showJobs = () => featureFlags[JOBS];
export const isInstanceStack = () => featureFlags[IS_INSTANCE];
export const getDefaultRoute = (tenant: string) => (tenant === "silq" ? "/datasets" : "/summary");
export const getBackendUrl = () => {
  return API_URL;
};
export const isSSOEnabled = () => {
  if (
    ENV === "local" &&
    (window.location.hostname.includes("localhost") ||
      window.location.hostname.includes("3000.app.github.dev"))
  )
    return false;
  return featureFlags[SSO_ENABLED];
};
export const showEnterpriseDataDiscovery = () => featureFlags[SHOW_ENTERPRISE_DATA_DISCOVERY];
export const showEnterpriseEditionSuggestion = () =>
  featureFlags[SHOW_ENTERPRISE_EDITION_SUGGESTION];
export const shouldRedirectToTeamSpends = () => featureFlags[SHOULD_REDIRECT_TO_TEAM_SPENDS];
export const showWorkflow = () => featureFlags[SHOW_WORKFLOW];
export const showAzureDatabricksConnections = () => featureFlags[SHOW_AZURE_DATABRICKS_CONNECTIONS];
export const isMegaTenant = () => getTenant() === MEGA_TENANT;
